import React, { useState, useEffect, useRef } from 'react';
import AddToCart from "../../../component/custom/AddToCart";
import RefreshStockButton from "../../ProductListing/RefreshStockButton";
import Product from '@system/config/product';
import DisplayQtyMinQtyMult from "../../../component/custom/DisplayQtyMinQtyMult";
import PriceTable from "../../../component/custom/PriceTable";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import liveAuth from 'src/helper/liveAuth';
import System from 'src/helper/system';
import FactoryLeadTimeDisplay from 'src/component/custom/FactoryLeadTimeDisplay';
import { useCartStore } from "../../../hooks/cart";
import { isArray, isNumber } from "underscore";
import Helper from 'src/helper/Helper';
import $ from "jquery";
import FadeInOut from "../../../component/Global/FadeInOut";
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import StripPriceLoader from 'src/component/Global/StripPriceLoader';
import { useProductStore } from 'src/hooks/product';
import QuantityPicker from 'src/component/custom/QuantityPicker';
import Constants from 'src/helper/Constants';
import SpecialOffer from 'src/component/custom/SpecialOffer';
import Bom from "@system/config/bom";
import { useBOMStore } from 'src/hooks/bom';
import AxiosIndicatorRunTimeLoader from 'src/component/Global/AxiosIndicatorRunTimeLoader';
import ProductInventoryDisplay from 'src/component/custom/ProductInventoryDisplay';
import CustomerPartNumberOptions from 'src/component/custom/CustomerPartNumberOptions';

const ProductDetailBuyBox = (props) => {
    const { productDetail, setParentClass } = props
    const [__check] = useAxiosIndicatorCheck();
    const [isFirstLoad, setIsFirstLoad] = useState(true)
    const [{ }, { get_product_assets }, { },] = useProductStore();
    const [{ }, { get_inventory_by_id, get_inventory_params, get_inventory_by_distributor, get_pricing_by_id, get_current_price_by_quantity }, { }] = useProductInventoryPriceStore();
    const [{ CART_BEFORE_TO_SEND_SERVER }, { get_display_status_button }, { }] = useCartStore();
    const [isDisplay, setDisplay] = useState(true);
    const [isToolBarPresent, setIsToolBarPresent] = useState(false);
    const [expandBox, setExpandBox] = useState(false);
    const expandVal = useRef(expandBox);
    const orderBlock = System.avUserInfoData.orderBlock
    const { systemModules: { PDP } } = Constants
    const [{ }, { }, { add_part_to_bom, create_bom, create_params_for_add_part_to_bom }] = useBOMStore();
    const [loadfetchInventoryFromServer, set_loadfetchInventoryFromServer] = useState(false);

    useEffect(() => {
        let defaultPosition = 0;
        const BUY_BOX_FIXED_CLASSNAME = "fixed-buy-box";
        let headerHeight = document?.getElementsByClassName("navbar navbar-default white") ? document?.getElementsByClassName("navbar-default")[0]?.clientHeight : 65;
        const adminToolBarHeight = document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")?.length > 0 ? document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")[0]?.clientHeight : 0;

        if (adminToolBarHeight > 0) {
            setIsToolBarPresent(true);
            headerHeight = headerHeight + adminToolBarHeight;
        }

        const scrollEvent = e => {


            const ele = document.getElementById("stock-box-pdp");
            if (defaultPosition === 0) {
                defaultPosition = ele.getBoundingClientRect().y;
            }
            const pyOffset = window.pageYOffset;
            if (pyOffset + headerHeight > defaultPosition + ele.clientHeight) {
                // add class to see fixed box
                if (setParentClass) {
                    setParentClass(BUY_BOX_FIXED_CLASSNAME);
                    if (expandVal.current && isDisplay) {
                        setDisplay(false);
                    }
                }
            } else {
                // remove class to see fixed box  


                setDisplay(true);
                if (setParentClass) {
                    setParentClass('');
                }
            }
        }
        document.addEventListener("scroll", scrollEvent);
        return () => {
            document.removeEventListener("scroll", scrollEvent)
        }
    }, [])

    useEffect(() => {
        expandVal.current = expandBox;
    }, [expandBox]);

    useEffect(() => {
        if (!__check(['PRODUCT_DETAIL_API_CALL_ON_PAGE_LOADING', 'PRODUCT_ASSET_API_CALL']).status && isFirstLoad) {
            setIsFirstLoad(false)
        }
    }, [__check(['PRODUCT_DETAIL_API_CALL_ON_PAGE_LOADING', 'PRODUCT_ASSET_API_CALL']).status])

    const getInventory = () => {
        return get_inventory_by_id(productDetail?.ItemNumber)
    };

    const getPricing = () => {
        return get_pricing_by_id({ ItemNumber: productDetail.ItemNumber })
    };

    const openQuoteBox = () => {
        !liveAuth.check() ? System.popup('GuestPopupActionButton', {
            title: 'Request a Quote',
            body: 'Sign-in/Register to get a Quote',
            yesButton: 'Sign In / REGISTER', closeButton: 'cancel'
        }) :
            System.popup('QuotePopup', {
                single_product: productDetail, addFrom: PDP, single_product_pricing_list: getPricing()
            })
    }

    const openAddToBOM = async (e) => {
        if (liveAuth.check()) {
            let _product = {
                ...e,
                QtyMin: CART_BEFORE_TO_SEND_SERVER[e.ItemNumber]?.quantityUpdateToCart || e.QtyMin
            };
            System.popup('AddToBOMPopup', { single_product: _product, addFrom: PDP })

        } else {
            const guestBomID = localStorage.getItem(System.storageName.GUEST_BOM_ID)
            const params = await create_params_for_add_part_to_bom(e)

            if (guestBomID) {
                const addPart = await add_part_to_bom(params)
                if (addPart?.data) {
                    redirectToBOM(guestBomID);
                }
            } else {
                const newBom = await create_bom(params, Constants.systemModules.PDP);
                if (newBom?.data) {
                    redirectToBOM(newBom.data);
                }
            }
        }

    };

    const redirectToBOM = (bomId) => {
        window.location.href = Bom.getBomDetailByIdRouteURL(
            bomId, { go: System.getParams().go }
        )
    };

    const pricing_single_display = get_current_price_by_quantity(getPricing(), CART_BEFORE_TO_SEND_SERVER[productDetail?.ItemNumber]?.quantityUpdateToCart,true)

    const displayPricingBasedOnSingleProduct = (module) => {
        return get_display_status_button(productDetail, getPricing(), getInventory(), module)
    };

    const displayMarketPrice = (pricing_single_display) => {
        if (pricing_single_display?.marketPrice) {
            let amt = Number(parseFloat(pricing_single_display.marketPrice));
            return System.getFormatNumber({ amount: amt, isDisplaySymbol: false });
        }
        return false;
    }

    const dispatchAllAttributeSelection = () => {
        if (!productDetail || !productDetail.Attributes || productDetail.Attributes.length === 0) {
            console.error("Product details or attributes are missing.");
            return;
        }
        const allValues = productDetail?.Attributes.reduce((acc, item) => {
            const key = Helper.anythingToCamel(item.ATTRNAME);
            if (!acc[key]) {
                acc[key] = { s: [{ value: item.ATTRVAL }], main_label: item.ATTRNAME };
            } else {
                acc[key].s.push({ value: item.ATTRVAL });
            }
            return acc;
        }, {});

        const encodedUrl = btoa(JSON.stringify(allValues));
        window.location.href = Product.getProductListingPageRouteURL() + '?' + $.param({
            go: encodedUrl,
            appendFacadeOptions: 'yes'
        });
    }


    const fetchInventoryFromServer = async () => {
        set_loadfetchInventoryFromServer(true)
        const params = [];

        const param = get_inventory_params(productDetail)
        if (param) {
            params.push(param)
        }

        if (params && params.length) {
            await get_product_assets(params, { isPriceCall: false })
        }
        set_loadfetchInventoryFromServer(false)
    };
    return (
        <>
            {productDetail &&
                <FadeInOut show={true} duration={500} className={`${isDisplay ? 'stock-box' : 'stock-box stock-box-small'} ${isToolBarPresent ? 'toolbar-visible' : 'toolbar-hidden'}`}>

                    {__check(['PRODUCT_DETAIL_API_CALL_ON_PAGE_LOADING', 'PRODUCT_ASSET_API_CALL']).status && isFirstLoad ?
                        <StripPriceLoader /> :
                        <>
                            <div className={isDisplay ? 'stockbox-show' : 'stockbox-hide'}>
                                {__check(['PRODUCT_INVENTORY_API_CALL']).status === false && (get_inventory_by_distributor(productDetail, getInventory()) <= 0) && productDetail?.Attributes.length > 0 &&

                                    <div className="stock-outofbox text-black">
                                        <i className={'fa fa-exchange me-2'}></i>
                                        <b className="me-3">Out of stock part</b>
                                        <a href={void (0)} onClick={() => {
                                            dispatchAllAttributeSelection()
                                        }} className="ext-black"><u>View similar parts</u></a>
                                    </div>
                                }
                                <div className="stock-price-title">
                                    {loadfetchInventoryFromServer ? <AxiosIndicatorRunTimeLoader /> :
                                        <ProductInventoryDisplay single_product={productDetail}
                                            single_product_inventory={getInventory()} isFromPDP={true} />
                                    }
                                    {!productDetail?.SoftwareDownloadFlag &&
                                        <div className="refresh-link">
                                            <RefreshStockButton
                                                fetchInventoryFromServer={fetchInventoryFromServer}
                                                label={'Refresh Stock'}
                                            />
                                        </div>
                                    }
                                </div>
                                {!productDetail?.isPartnerDistributor &&
                                    <div className="">
                                        <div className="factory-lead-title text-black-stone factory-lead-title-text">
                                            <FactoryLeadTimeDisplay
                                                single_product={productDetail}
                                                single_product_inventory={getInventory()}
                                            />
                                        </div>
                                    </div>
                                }
                            </div>

                            <div className={isDisplay ? 'stockbox-show' : 'stockbox-hide'}>
                                <div className={orderBlock ? "stockbox-hide" : "stockbox-seprator"} />
                                <div className="stock-price-box">
                                    <div className={orderBlock ? "stockbox-hide" : "bs5 row g-4 flex-nowrap"}>
                                        <div className="col price-left">
                                            <div
                                                className={"mb-2 "}>
                                                {isArray(getPricing()) && getPricing().length > 0 &&
                                                    <b>Price for: Each</b>
                                                }
                                            </div>
                                            <SpecialOffer single_product={productDetail} single_product_pricing_list={getPricing()}
                                                single_product_inventory={getInventory()} />

                                            <div className='mb-3'>
                                                <div className="mb-1"><b>Quantity:</b></div>
                                                <div className="text-black-stone">
                                                    <DisplayQtyMinQtyMult
                                                        single_product={productDetail} />
                                                </div>
                                            </div>
                                            {displayPricingBasedOnSingleProduct('quoteLink') && !(displayPricingBasedOnSingleProduct('quote') && displayPricingBasedOnSingleProduct('cart') === false) && <>Need More? <a className="text-blue"
                                                onClick={() => openQuoteBox()}>Click To Quote</a></>}

                                        </div>
                                        <div className="col-6 ps-0">

                                            {(displayPricingBasedOnSingleProduct('cart') && pricing_single_display && pricing_single_display.marketPrice && CART_BEFORE_TO_SEND_SERVER[productDetail?.ItemNumber]?.is_updated_qty) ?
                                                <div className="price dense-hide mb-2">
                                                    <strong>
                                                        {window.mct} {window.mct !== window.mcs && <span>{window.mcs}</span>}:
                                                    </strong>
                                                    <div className="pull-right font-bold">
                                                        {displayMarketPrice(pricing_single_display)}
                                                    </div>
                                                </div>
                                                : <></>
                                            }
                                            <div className="d-flex">
                                                <QuantityPicker
                                                    single_product={productDetail}
                                                    single_product_inventory={getInventory()}
                                                    single_product_pricing_list={getPricing()}
                                                />
                                            </div>
                                            <CustomerPartNumberOptions
                                                single_product={productDetail}
                                            />
                                            <PriceTable
                                                auto_select_from_cart_data={false}
                                                linesToDisplay={3}
                                                single_product={productDetail}
                                                single_product_inventory={getInventory()}
                                                single_product_pricing_list={getPricing()} />
                                        </div>
                                    </div>
                                    <div className="stockbox-seprator" />
                                    <div className="stock-subtotal-wrapper">
                                        {(pricing_single_display?.marketPrice &&
                                            CART_BEFORE_TO_SEND_SERVER[productDetail?.ItemNumber]?.quantityUpdateToCart &&
                                            displayPricingBasedOnSingleProduct('cart')) ?
                                            <>
                                                <div className="stock-subtotal-header">
                                                    <div className="stock-subtotal-title">SubTotal: </div>
                                                    <div className="stock-subtotal-desc">
                                                        {isNumber(pricing_single_display.marketPrice * CART_BEFORE_TO_SEND_SERVER[productDetail?.ItemNumber].quantityUpdateToCart) ?
                                                            System.getFormatNumber({ amount: Number(pricing_single_display.marketPrice * CART_BEFORE_TO_SEND_SERVER[productDetail?.ItemNumber].quantityUpdateToCart), maximumFractionDigits: 2 }) : ''}
                                                    </div>
                                                </div>
                                            </>
                                            :
                                            ''
                                        }
                                        <div className="stock-subtotal-actions">
                                            <div className="bs5 row g-3">
                                                <div className="col-6">
                                                    <button className="bs5 btn btn-secondary btn-sm w-100"
                                                        onClick={() => openAddToBOM(productDetail)}>ADD TO BOM
                                                    </button>
                                                </div>
                                                <div className="col-6">
                                                    <AddToCart
                                                        product_detail={true}
                                                        single_product_pricing_list={getPricing()}
                                                        single_product_inventory={getInventory()}
                                                        single_product={productDetail}
                                                        isFrom={PDP} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={isDisplay ? 'sticky-footer' : 'sticky-footer sticky-arrow-down'}>
                                <button className={isDisplay ? "expand" : "expand"} onClick={() => { setDisplay(prev => !prev); setExpandBox((prevState) => !prevState) }}>
                                    <span className="fa sticky_footer_span fa-angle-double-up"></span>
                                </button>
                            </div>

                        </>
                    }
                </FadeInOut>

            }
        </>
    );
}

export default ProductDetailBuyBox;